import { createSlice } from '@reduxjs/toolkit'
import homeApiResponseParser from 'src/modules/home/homeApiResponseParser'
import homeConstants from 'src/modules/home/homeConstants'
import HomeService from 'src/modules/home/HomeService'
import Errors from 'src/modules/shared/error/errors'
import { VideoCategory, VideoObject } from 'src/modules/shared/Types'

export interface HomeState {
  defaultVideoUrl?: string
  fetchVideosLoading: Array<string>
  onDemandVideos: { [key: string]: Array<VideoObject> }
}

const initialState: HomeState = {
  fetchVideosLoading: [],
  defaultVideoUrl: '',
  onDemandVideos: {},
}

const homeSlice = createSlice({
  name: 'homeSlice',
  initialState: initialState,
  reducers: {
    fetchVideosStarted: (state, action) => {
      state.fetchVideosLoading = [...state.fetchVideosLoading, action.payload.categoryName]
    },
    fetchVideosError: (state, action) => {
      state.fetchVideosLoading = []
    },
    fetchVideosSuccess: (state, action) => {
      state.fetchVideosLoading = state.fetchVideosLoading.filter((x) => x !== action.payload.categoryName)
      state.onDemandVideos[`${action.payload.categoryName}`] = action.payload.videos
    },
    fetchDefaultVideoUrlSuccess: (state, action) => {
      state.defaultVideoUrl = action.payload.defaultVideoUrl
    },
  },
})

export const homeThunkActions = {
  fetchOnDemandVideos: () => async (dispatch, getState) => {
    fetchVideosForCategory(homeConstants.categories[0], dispatch)
    fetchVideosForCategory(homeConstants.categories[1], dispatch)
    fetchVideosForCategory(homeConstants.categories[2], dispatch)
    fetchVideosForCategory(homeConstants.categories[3], dispatch)
    fetchVideosForCategory(homeConstants.categories[4], dispatch)
  },
  fetchDefaultUrl: () => async (dispatch) => {
    await fetchDefaultUrl(homeConstants.categories[5], dispatch)
  },
}

const fetchVideosForCategory = async (category: VideoCategory, dispatch) => {
  dispatch(homeSlice.actions.fetchVideosStarted({ categoryName: category.id }))
  try {
    const response = await HomeService.fetchVideosForCategory(category.apiString)
    const videos: Array<VideoObject> = homeApiResponseParser.readVideosResponse(response.data)
    dispatch(homeSlice.actions.fetchVideosSuccess({ videos: videos, categoryName: category.id }))
  } catch (error) {
    Errors.handle(error)
    dispatch(homeSlice.actions.fetchVideosError({ categoryName: category.id }))
  }
}

const fetchDefaultUrl = async (category: VideoCategory, dispatch) => {
  try {
    const response = await HomeService.fetchVideosForCategory(category.apiString)
    const defaultVideoUrl = response.headers['location']
    console.log('Default video URL response:', response)
    console.log('Default video URL response:', defaultVideoUrl)
    
    dispatch(homeSlice.actions.fetchDefaultVideoUrlSuccess({ defaultVideoUrl: response?.data?.url }))
  } catch (error) {
    Errors.handle(error)
    // dispatch(homeSlice.actions.fetchVideosError({ categoryName: category.id }))
  }
}

export default homeSlice
